import React, { useState, useEffect, useRef } from "react";
import {
  Checkbox,
  FormControlLabel,
} from "@material-ui/core";
import Button from "components/CustomButtons/Button.js";
import WebApi from "api/ApiConstants";
import { useTheme } from "@material-ui/core/styles";
import OaFormAlerts from "pages/components/OaFormAlerts";
import SubmitProgress from "pages/module/flight/fixedDeparture/SubmitProgress";
import { AppConstant } from "appConstant";
import OaButtonDownloadPDF from "pages/components/OaButtonDownloadPDF";
import { DOWNLOAD_FLIGHT_TICKET_PDF } from "api/ApiConstants";
import { localforageGetItem } from "oautils/oaForageUtils";
import { useHistory, useParams } from "react-router-dom/cjs/react-router-dom";
import FlightTicketPrint from "./print/FlightTicketPrint";
import FlightTicketCard from "./ticketComponents/FlightTicketCard";
import { extractCssRules } from "./print/PrintStylesExtractor";
import FlightUpdateMarkup from "./ticketComponents/FlightUpdateMarkup";
import FlightTicketSendEmail from "./ticketComponents/FlightTicketSendEmail";
import FlightInvoiceButton from "./ticketComponents/FlightInvoiceButton";
import PDFViewerButton from "pages/components/OaPdfViewer";

const FlightTicket = (props) => {
  const theme = useTheme();
  const ticketTemplateRef = useRef();
  const isMounted = useRef(false);
  const history = useHistory();
  const params = useParams();

  const [isSuccess, setIsSuccess] = useState(false);
  const [isError, setIsError] = useState(false);
  const [isSaving, setIsSaving] = useState(false);
  const [infoText, setInfoText] = useState("");
  const [ticketId, setTicketId] = useState(null);

  const [data, setData] = useState({});
  const [isLoading, setLoading] = useState(true);
  const [isUpdateMarkup, setIsUpdateMarkup] = useState(false);
  const [markup, setMarkup] = useState(0);
  const [isSendEmail, setIsSendEmail] = useState(false);
  const [receiverEmail, setReceiverEmail] = useState("");
  const [isStatusLoading, seStatustLoading] = useState(false);
  const [loggedInUserId, setLoggedInUserId] = useState(0);
  const [state, setState] = useState({
    isAddressHide: false,
    isFareHide: false,
    isPerPassenger: false,
    isGSTHide: false,
    isMarkupUpdate:false,
  });
  const [userTypeInfo, setUserTypeInfo] = useState("G");
  const [execPrint, setExecPrint] = useState(false);
  const [printDom, setPrintDom] = useState(null);
  const [printContent, setPrintContent] = useState(null);
  const [printStyles, setPrintStyles] = useState(null);
  const [showInvoiceModal, setShowInvoiceModal] = useState(false);

  const flightTicketDownloadRequest = {
    flightDetailReq: {
      loggedInUserId: "" + loggedInUserId,
      transactionId: ticketId,
      partnerId: loggedInUserId != null && loggedInUserId != 0 ? 1002 : 1001
    },
    currency: "INR",
    isAddressHide: state.isAddressHide,
    isFareHide: state.isFareHide,
    isGSTHide: state.isGSTHide,
    isPerPassenger: state.isPerPassenger,
  };

  const handlePrint = () => {
    if (ticketTemplateRef.current && data && state) {
      setPrintStyles(extractCssRules(document.styleSheets));
      const printContent = ticketTemplateRef.current.innerHTML;
      const printWindow = window.open("", "_blank");
      setPrintDom(printWindow);
      setPrintContent(printContent);
      setExecPrint(true);
    }
  };

  const handleChange = (name) => (event) => {
    setState({ ...state, [name]: event.target.checked });
  };

  const getTicketData = (transactionId) => {
    return new Promise((resolve, reject) => {
      WebApi.getTicketData(
        { transactionId: transactionId },
        (response) => {
          if (response?.success) {
            resolve(response.data);
          } else {
            setInfoText("Internal error: failed to get ticket data!");
            setIsError(true);
          }
        },
        (error) => {
          reject([]);
          console.error("Error", error);
          setInfoText("Internal error: failed to get ticket data!");
          setIsError(true);
        }
      );
    });
  };

  const sendEmail = () => {
    setIsSendEmail(true);
  };

  const updateMarkup = () => {
    setIsUpdateMarkup(true);
  };

  const openInvoiceModal = () => {
    setShowInvoiceModal(true);
  };

  const closeInvoiceModal = () => {
    setShowInvoiceModal(false);
  };

  const goToInvoice = (invoiceType) => {
    history.push(`/admin/voucher/${invoiceType}/${ticketId}`);
    //options user_invoice agent_invoice
  };

  const getUserDetails = (mountStatus) => {
    localforageGetItem("user-details", function (err, value) {
      if (mountStatus && value) {
        setLoggedInUserId(value.userId);
        setUserTypeInfo(value.userTypeAbv);
        flightTicketDownloadRequest.flightDetailReq = value.userTypeAbv != 'G' && value.userTypeAbv != 'R' ? 1002 : 1001;
      } else {
        console.error("error getting user details", err);
      }
    });
  };

  const initTicketData = () => {
    if (ticketId > 0) {
      getTicketData(ticketId).then(function (data) {
        setData(data);
        setReceiverEmail(data.agentInfo ? data.agentInfo.agentEmail : "");
        setLoading(false);
        setMarkup(data.flightSummary.agentMarkup);

        let counter = 0;

        if (data.bookingStatus !== "SuccessTkd") {
          on();
        }
        const myInterval = setInterval(() => {
          counter++;

          if (data.bookingStatus !== "SuccessTkd") {
            seStatustLoading(true);
            getTicketData(ticketId).then(function (data) {
              if (data.bookingStatus === "SuccessTkd" || counter === 8) {
                off();
                setData(data);
                clearInterval(myInterval);
              }
              seStatustLoading(false);
            });
          } else {
            seStatustLoading(false);
            clearInterval(myInterval);
          }
        }, 3500);
      });
    }
  };

  function on() {
    document.getElementById("overlay").style.display = "flex";
  }

  function off() {
    document.getElementById("overlay").style.display = "none";
  }

  useEffect(() => {
    isMounted.current = true;
    setLoading(true);
    if (params?.ticketId) {
      setTicketId(params?.ticketId);
    } else if (history.location.state?.tid) {
      setTicketId(history.location.state.tid)
    }

    return () => {
      isMounted.current = false;
      setPrintStyles(null);
      setPrintDom(null);
      setPrintContent(null);
    };
  }, []);

  useEffect(() => {
    if (updateMarkup && isSuccess) {
      initTicketData();
      setIsUpdateMarkup(false);
      setIsSuccess(false);
    }
  }, [updateMarkup, isSuccess]);

  useEffect(() => {
    getUserDetails(isMounted.current);
    if (ticketId) {
      initTicketData();
    }
  }, [ticketId, isMounted.current]);

  return (
    <div className="ticket-page-root">
      <OaFormAlerts
        isSaving={isSaving}
        isSuccess={isSuccess}
        isError={isError}
        infoText={infoText}
        setIsError={setIsError}
        setIsSuccess={setIsSuccess}
      />
      <div className="ticket-page-container">
        <div className="ticket-card action-container">
          {userTypeInfo &&
            userTypeInfo.corporateType != "corporate" &&
            userTypeInfo.userTypeAbv != "G" &&
            userTypeInfo.userTypeAbv != "R" && (
              <div className="flex-box ticket-row input-row">
                <div className="ticket-col">
                  <div className="flex-box ticket-element align-items-center">
                    <FormControlLabel
                      control={
                        <Checkbox
                          color="primary"
                          checked={state?.isAddressHide}
                          onChange={handleChange("isAddressHide")}
                          value="isAddressHide"
                        />
                      }
                      label="Hide Address"
                    />
                  </div>
                </div>
                <div className="ticket-col">
                  <div className="flex-box ticket-element align-items-center">
                    <FormControlLabel
                      control={
                        <Checkbox
                          color="primary"
                          checked={state?.isFareHide}
                          onChange={handleChange("isFareHide")}
                          value="isFareHide"
                        />
                      }
                      label="Hide Fare"
                    />
                  </div>
                </div>
                <div className="ticket-col">
                  <div className="flex-box ticket-element align-items-center">
                    <FormControlLabel
                      control={
                        <Checkbox
                          color="primary"
                          checked={state?.isGSTHide}
                          onChange={handleChange("isGSTHide")}
                          value="isGSTHide"
                        />
                      }
                      label="Hide GST"
                    />
                  </div>
                </div>
                <div className="ticket-col">
                  <div className="flex-box ticket-element align-items-center">
                    <FormControlLabel
                      control={
                        <Checkbox
                          color="primary"
                          checked={state?.isPerPassenger}
                          onChange={handleChange("isPerPassenger")}
                          value="isPerPassenger"
                        />
                      }
                      label="Passenger Wise"
                    />
                  </div>
                </div>
              </div>
            )
          }

          <div className="flex-box ticket-row action-row justify-space-between">
            <div className="ticket-col">
              <div className="flex-box ticket-element align-items-center">
                <Button
                  color="primary"
                  onClick={sendEmail}
                >
                  Email
                </Button>
                {/* <Button
                  color="primary"
                  onClick={handlePrint}
                >
                  Print e-Ticket
                </Button> */}
                <PDFViewerButton
                  label="Print e-Ticket"
                  api={DOWNLOAD_FLIGHT_TICKET_PDF}
                  searchParams={flightTicketDownloadRequest}
                />
                <OaButtonDownloadPDF
                  btnLabel="Download E-Ticket"
                  api={DOWNLOAD_FLIGHT_TICKET_PDF}
                  searchParams={flightTicketDownloadRequest}
                  defaultFileName="flight-eticket"
                />
                {userTypeInfo &&
                  userTypeInfo != "corporate" &&
                  userTypeInfo != "G" &&
                  userTypeInfo != "R" && (
                    <>
                      <Button color="primary" onClick={openInvoiceModal}>
                        Invoice
                      </Button>
                      <Button
                        color="primary"
                        onClick={updateMarkup}
                      >
                        Update Markup
                      </Button>
                    </>
                  )
                }
              </div>
            </div>
          </div>
        </div>
        <div className="ticket-row content-row">
          <div className="ticket-col w100p card flight-card-col">
            {isLoading ? (
              <CustomLoader />
            ) : (
              <FlightTicketCard
                data={data}
                state={state}
                markup={markup}
                isStatusLoading={isStatusLoading}
                appconst={AppConstant}
              />
            )}
          </div>
        </div>
      </div>
      <div ref={ticketTemplateRef} style={{ display: "none" }}>
        <FlightTicketPrint
          data={data}
          state={state}
          markup={markup}
          isStatusLoading={isStatusLoading}
          appconst={AppConstant}
          execPrint={execPrint}
          setExecPrint={setExecPrint}
          printContent={printContent}
          setPrintContent={setPrintContent}
          printDom={printDom}
          printStyles={printStyles}
          setPrintStyles={setPrintStyles}
        />
      </div>
      <FlightTicketSendEmail
        isSendEmail={isSendEmail}
        setIsSendEmail={setIsSendEmail}
        setIsLoading={setLoading}
        isSuccess={isSuccess}
        isError={isError}
        infoText={infoText}
        setIsSuccess={setIsSuccess}
        setIsError={setIsError}
        setInfoText={setInfoText}
        receiverEmail={receiverEmail}
        requestParams={flightTicketDownloadRequest}
      />
      <FlightUpdateMarkup
        isUpdateMarkup={isUpdateMarkup}
        setIsUpdateMarkup={setIsUpdateMarkup}
        setIsLoading={setLoading}
        isSuccess={isSuccess}
        isError={isError}
        infoText={infoText}
        setIsSuccess={setIsSuccess}
        setIsError={setIsError}
        setInfoText={setInfoText}
        ticketId={ticketId}
        markup={markup}
        setMarkup={setMarkup}
      />
      <FlightInvoiceButton
        goToInvoice={goToInvoice}
        handleClose={closeInvoiceModal}
        openInvoice={showInvoiceModal}
      />
      <style>{RootStyles(theme)}</style>
    </div>
  );
};

export default FlightTicket;

const CustomLoader = () => (
  <div
    style={{
      display: "flex",
      justifyContent: "center",
      alignItems: "center",
      height: "-webkit-fill-available",
    }}
  >
    {/* <CircularProgress disableShrink /> */}
    <SubmitProgress />
  </div>
);

const RootStyles = (theme) => `
  .ticket-page-root {
    display: flex;
    flex-direction: column;
    align-items: center;
    background-color: ${theme.palette.background.lightGrayDefault};
    padding: 10px 0;
    box-sizing: border-box;
  }

  .ticket-page-container {
    width: 100%;
    box-sizing: border-box;
    max-width: 210mm;
  }

  .ticket-root {
    background: transparent;
    box-sizing: border-box;
  }

  .ticket-card {
    width: 100%;
    max-width: 210mm;
    overflow: hidden;
    background-color: ${theme.palette.background.default};
    border-radius: 3px;
    padding: 20px 0;
  }

  .shadow-min {
    box-shadow: 0 1px 4px 0 rgba(0, 0, 0, 0.14);
  }

  .action-container {
    margin: 0 0 10px;
  }

  .ticket-row {
    width: 100%;
    box-sizing: border-box;
  }

  .ticket-row.action-row button {
    margin-right: 5px;
  }

  .ticket-row.action-row button :last-child {
    margin-right: 0;
  }

  .ticket-col.flight-card-col {
    min-height: 80vh;
  }

  .w100p {
    width: 100%;
  }

  .w50p {
    width: 50%;
  }

  .w40p {
    width: 48%;
  }

  .w30p {
    width: 33.33%;
  }

  .w25p {
    width: 25%;
  }

  .w12p {
    width: 12.5%;
  }

  .ticket-element {
    padding: 10px 15px;
  }

  .ticket-element label {
    font-size: 13px;
    font-weight: 500;
    text-transform: uppercase;
  }

  .ticket-element input[type="checkbox"] {
    margin-left: 8px;
    cursor: pointer;
  }

  .ticket-element button, .ticket-element .custombtn-container {
    text-transform: uppercase;
    max-width: 200px;
    border: solid 1px ${theme.palette.secondary.main};
    background: ${theme.palette.secondary.main};
    color: ${theme.palette.secondary.contrastText};
    height: 40px;
    border-radius: 4px;
    transition: ease 0.4s;
    font-size: 13px;
    font-weight: 500;
    padding: 0 20px;
  }

  .ticket-element button:hover, .ticket-element .custombtn-container:hover, 
  .ticket-element button:focus, .ticket-element .custombtn-container:focus {
    background: ${theme.palette.secondary.contrastText};
    border: solid 1px
      ${theme.palette.secondary.contrastText};
    color: ${theme.palette.secondary.main};
    -webkit-box-shadow: 0px 0px 7px 0px rgba(0, 0, 0, 0.7);
    -moz-box-shadow: 0px 0px 7px 0px rgba(0, 0, 0, 0.7);
    box-shadow: 0px 0px 7px 0px rgba(0, 0, 0, 0.7);
  }

  .ticket-element .custombtn-container.close-button {
    height: auto;
    width: auto;
  }

  .modal-content .close-btn {
    right: 5px;
    top: 0px;
    z-index: 9;
  }

  .align-items-center {
    flex-wrap: wrap;
  }

  .page-break {
    height: 10px;
  }

  .form-element {
    padding: 20px 10px;
    text-align: left;
    flex-grow: 1;
  }

  .form-element input {
    width: 100%;
    color: ${theme.palette.text.dark};
    border: solid 1px ${theme.palette.background.lightGrayFaded};
    height: 40px;
    border-radius: 4px;
    padding-left: 10px;
    padding-right: 10px;
  }

  .form-element input:placeholder {
    font-weight: 500;
    font-size: 14px;
  }

  .form-element input:focus {
    outline: none;
  }

  .form-element label, .form-element .text-header {
    font-size: 13px;
    padding: 0 8px;
    width: 100%;
    text-transform: uppercase;
    font-weight: 500;
    color: ${theme.palette.text.dark};
  }

  .form-element.btn-element {
    padding: 30px 10px 10px;
    position: relative;
    width: max-content;
    min-width: 100px;
  }

  .form-element.btn-element button {
    padding: 8px 15px 8px 10px;
    text-transform: uppercase;
    width: 100%;
  }

  .form-element .btn-submit {
    padding: 0 15px;
    border-radius: 4px;
    font-size: 14px;
    font-weight: 600;
    background: ${theme.palette.primary.main};
    color: ${theme.palette.primary.contrastText};
    border: solid 1px ${theme.palette.primary.main};
    transition: ease 0.4s;
  }

  .form-element .btn-submit:disabled {
    cursor: not-allowed;
  }

  .form-element .btn-submit:hover {
    background: ${theme.palette.background.default};
    color: ${theme.palette.primary.main};
  }

  .form-element.invoice-type-select-div {
    gap: 10px;
  }

  .form-element.invoice-type-select-div button {
    padding: 10px 20px;
  }

  .flex-box {
    display: flex;
  }

  .align-items-center {
    align-items: center;
  }

  .justify-space-between {
    justify-content: space-between;
  }

  @media (max-width: 1100px) {
    .ticket-page-container {
      max-width: 100%;
    }

    .ticket-page-container .input-row, .ticket-page-container .action-row {
      box-sizing: border-box;
    }

    .ticket-page-container .action-row .ticket-col {
      width: 100% !important;
    }

    .ticket-page-container .ticket-card {
      max-width: 100%;
    }

    .ticket-page-container .flex-box {
      flex-wrap: wrap;
    }

    .ticket-page-container .traveller-details-table,
    .ticket-page-container .gst-details-table {
      min-width: 100%;
    }
  }

  @media (max-width: 1062px) {
    .ticket-page-container .ticket-itin-row .carrier-identity-col {
      width: 200px;
    }
  }

  @media (max-width: 1002px) {
    .ticket-page-container .ticket-itin-row .carrier-identity-col {
      width: 115px;
    }
  }

  @media (max-width: 960px) {
    .ticket-page-container .fare-details-row-row .w40p {
      width: 100% !important;
    }

    .ticket-page-container .traveller-details-table-container {
      width: 100vw !important;
      overflow-x: auto;
    }

    .ticket-page-container .traveller-details-table,
    .ticket-page-container .gst-details-table {
      width: 940px !important;
    }
  }

  @media (max-width: 600px) {
    .ticket-page-container .corp-identity-row .ticket-col,
    .ticket-page-container .ticket-notification-row .ticket-col,
    .ticket-page-container .ticket-itin-row .ticket-col,
    .ticket-page-container .traveller-details-row .ticket-col,
    .ticket-page-container .fare-details-row .ticket-col,
    .ticket-page-container .additional-info-row .ticket-col {
      width: 100% !important;
    }
  }
`;
